<template>
  <v-form ref="form">
    <dialog-view
      :open="dataState.isModalOpen"
      :title="(dataState.modalData===null ? '' : typeof dataState.modalData?.id=='undefined' ? 'Создать ожидание визита' : 'Ожидание визита #'+dataState.modalData.id)"
      content-full-size @cancel="$emit('cancel')"
    >
      <template v-slot:barActions>
        <log v-if="dataState.modalData?.id" entity-name="VisitPlan" :entity-id="dataState.modalData.id"/>
      </template>
      <template v-slot:content v-if="dataState.modalData!==null">
        <div class="d-flex justify-center my-10" v-if="userSpecsState.isLoading">   
            <v-progress-circular
            indeterminate
            color="primary"
          ></v-progress-circular>    
        </div>  
        <template v-else>
          <div class="caption mx-4 mt-2">Клиент:</div>
          <div class="mx-4 mb-2">
            {{dataState.modalData.user.lastName=== null ? '': dataState.modalData.user.lastName}}
            {{dataState.modalData.user.firstName=== null ? '': dataState.modalData.user.firstName}}
            {{dataState.modalData.user.secondName=== null ? '': dataState.modalData.user.secondName}}
            <v-btn icon depressed :href="'/panel/user/client/'+dataState.modalData.user.id+'/'" target="_blank" small>
              <v-icon small>mdi-open-in-new</v-icon>
            </v-btn>
            <div><call-phone :phone="dataState.modalData.user.phone" v-if="dataState.modalData.user.phone" /></div>
          </div>
          <v-divider class="mb-2"/>
          <v-tabs v-model="userOrSpec" class="px-4">
            <v-tab>Специалист</v-tab>
            <v-tab-item class="pt-4">
                <autocomplete-single name="Специалист" :items="usersSpecs" :select.sync="userSelected" required>
                  <template v-slot:customInfo="{item}">
                    <v-row no-gutters class="py-2" style="max-width: 400px;">
                      <v-col cols="12" class="subtitle-2">
                        <v-list-item-avatar class="user mr-3" size="32">
                          <img :src="item.imageUrl" alt="" v-if="item.imageUrl">
                        </v-list-item-avatar>
                        {{$tools.userFullName(item)}}
                      </v-col>
                      <v-col cols="12">
                        <template v-for="(userSpec,index) in item.userSpecs">
                        <div class="caption" v-if="!$tools.isEmpty(userSpec.commentAdmin)" :key="'us_'+index">
                          <div>
                            <v-avatar :color="userSpec.comDiv.comBranch.color" size="10" class="mr-1" style="margin-top:-2px"/>
                            {{userSpec.spec.name}} ({{ userSpec.comDiv.comBranch.name }})
                          </div>
                            <v-icon class="ml-2 mr-1" small>mdi-comment-text-outline</v-icon>
                            {{userSpec.commentAdmin}}
                        </div>
                      </template>
                      </v-col>
                    </v-row>
                  </template>
                  <template v-slot:selectedInfo="{item}">
          
                    <v-list-item-avatar class="user ml-0 mr-2" size="32">
                      <img :src="item.imageUrl" alt="" v-if="item.imageUrl">
                    </v-list-item-avatar>
                    {{$tools.userFullName(item, true)}} 
                    <v-btn 
                        @click.stop
                        x-small
                        class="ml-3"
                        icon depressed :href="`/panel/user/spec/${item.id}/`" target="_blank">
                      <v-icon small>mdi-open-in-new</v-icon>
                    </v-btn>
                
                  </template>     
              </autocomplete-single>
    
              <v-alert
                outlined
                type="warning"
                prominent
                icon="mdi-exclamation"
                v-if="userOrSpec===0&&userSelected&&Object.keys(userSelected).length>0&&userSpecsState.isSuccess&&userSelectedEvents.length===0"
              >
                нет доступных дат
              </v-alert>

            </v-tab-item>
            <v-tab>Специальность</v-tab>
            <v-tab-item class="pt-4">
              <spec-autocomplete-single :select.sync="specSelected" />
            </v-tab-item>
          </v-tabs>
          <v-divider class="mb-4"/>

          <checkbox-field v-show="userOrSpec===0" class="mx-4 mb-4" name="Только даты с активным расписанием" :value.sync="onlyActiveUserSpecPlans"/>

          <v-menu v-if="!dataState.modalData.isLiveList" v-model="beginDateState.isModalOpen" :close-on-content-click="false" offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                  v-bind="attrs" v-on="on"
                  v-model="beginDateState.modalData"
                  :rules="formFieldRules.required"
                  label="Дата" class="mx-4 mb-4" outlined dense hide-details="auto" readonly/>
            </template>
            <v-date-picker
                v-model="beginDateState.modalData1"
                @change="beginDateState.modalClose($tools.dateTimeFormat(beginDateState.modalData1, 'DD.MM.YYYY'), beginDateState.modalData1)"
                no-title
                :first-day-of-week="1"
                :width="393"
                :allowed-dates="userOrSpec===0&&onlyActiveUserSpecPlans ? allowedDates : null"
                :events="userSelectedEvents"
                :event-color="date => userSelectedEventsColors[date]"
                color="primary"
            />
          </v-menu>

          <autocomplete-single class="px-4" v-show="userOrSpec===0&&beginDateState.modalData" name="Специализация" :items="userSpecs" :select.sync="userSpecSelected" required>
            <template v-slot:customInfo="{item}">
              <div class="v-list-item__title ">
              <v-avatar :color="item.comDiv.comBranch.color" size="10" class="mr-1" style="margin-top:-2px"/>
              {{item.spec.name}}  ({{item.comDiv.comBranch.name}})
              </div>
            </template>
            <template v-slot:selectedInfo="{item}">
              <v-avatar :color="item.comDiv.comBranch.color" size="10" class="mr-1" style="margin-top:-2px"/>
              {{item.spec.name}}  ({{item.comDiv.comBranch.name}})
            </template>
          </autocomplete-single>

          <v-textarea v-model="dataState.modalData.comment" label="Комментарий" class="mx-4 mb-4" rows="1" auto-grow hide-details outlined dense/>

          <div class="px-4" v-if="sameVisitPlans.length>0">
            <v-alert
            outlined
            type="warning"
            class="mb-0"
          >
            Найдено в {{dataState.modalData.isLiveList ? 'листе живой очереди' : 'листе ожидания'}}
          </v-alert>

            <v-list>
              <v-list-item-group
                color="primary"
              >
                <v-list-item v-for="v in sameVisitPlans" :key="v.id" @click="$emit('open',v);">
                  <v-list-item-icon>
                    #{{v.id}} ({{ $tools.date(v.begin) }})
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>{{v.comment}}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </div>


          <div class="mx-4 mb-4" v-if="dataState.modalData.id!==undefined">
            <v-btn block color="primary" depressed @click="visitCreate()">Создать визит</v-btn>
          </div>

        </template>

      </template>
      <!-- end content -->

      <template v-slot:actions v-if="dataState.modalData!==null">
        <dialog-view
            :title="'Удалить ожидание визита #'+dataState.modalData.id+'?'"
            acceptName="Удалить"
            @acceptAction="deleteAction()"
            :loading="deleteState.isLoading"
            v-if="dataState.modalData.id!==undefined"
        >
          <template v-slot:activator>
            <v-btn text color="error" class="mr-2">Удалить</v-btn>
          </template>
        </dialog-view>
        <v-btn color="primary" text @click="createOrUpdate()" :loading="updateState.isLoading">Сохранить</v-btn>
      </template>

    </dialog-view>
  </v-form>
</template>


<script>

import State from "@/plugins/state";
import axios from "axios";
import Api from "@/Api";
import DialogView from "@/components/DialogView";
import {FormFieldRules} from "@/plugins/formFieldRules";
import moment from "moment";
import CallPhone from "@/components/CallPhone.vue";
import Log from "@/views/Log/Log";
import CheckboxField from "@/componentsV2/base/CheckboxField.vue";
import AutocompleteSingle from "@/componentsV2/base/AutocompleteSingle.vue";
import SpecAutocompleteSingle from "@/componentsV2/custom/SpecAutocompleteSingle.vue";
import {
  Entity_UserSpecPlan,
  Entity_UserSpec, 
  Entity_User, 
  Entity_Spec, 
  Entity_ComPlace, 
  Entity_ComRoom, 
  Entity_ComFloor, 
  Entity_ComBuilding, 
  Entity_ComBranch,
  Entity_ComDiv,
  Entity_VisitPlan,
} from "../../../EntityStoreCacheService";


export default {
  components: {
    DialogView, 
    CallPhone, 
    CheckboxField, 
    Log,
    AutocompleteSingle,
    SpecAutocompleteSingle
  },
  props:['state','usersSpecs'],
  data: () => ({
    dataState: new State(),
    updateState: new State(),
    deleteState: new State(),
    userSpecsState: new State(),
    formFieldRules: FormFieldRules,

    userOrSpec:0,

    userSelected:null,
    userSpecSelected:null,
    specSelected:null,

    userSpecs:[],

    beginDateState:new State(),
    beginTime:null,

    userSelectedEvents: [],
    userSelectedEventsColors: {},
    userSelectedEventsSpecs: {},
    alreadyCreated:false,
    sameVisitPlans: [],
    onlyActiveUserSpecPlans: true
  }),
  watch:{
    state: {
      deep: true,
      handler() {
        if(this.state.isModalOpen){
          this.$refs.form.resetValidation();
          this.dataState.modalOpen(JSON.parse(JSON.stringify(this.state.modalData)));
          this.sameVisitPlans = [];

          if(typeof this.state.modalData.id==='undefined'){
            this.userOrSpec = 0;
            this.userSelected = null;
            this.userSpecSelected = null;
            this.specSelected = null;
            this.onlyActiveUserSpecPlans = true;
          } else {
            this.beginDateState.modalData = this.$tools.dateTimeFormat(this.dataState.modalData.begin, 'DD.MM.YYYY');
            this.beginDateState.modalData1 = this.$tools.dateTimeFormat(this.dataState.modalData.begin, 'YYYY-MM-DD');

            if(this.dataState.modalData.userSpec===null){
              this.userOrSpec = 1;
              this.userSelected = null;
              this.specSelected = this.dataState.modalData.spec;
            } else {
              this.userOrSpec = 0;
              this.specSelected = null; 
              this.userSelected = this.dataState.modalData.userSpec.user;    
              this.onlyActiveUserSpecPlans = true;          
            }   
            
          }

          if (typeof this.dataState.modalData.id !=='undefined') {
            this.alreadyCreated = true;
          }

      
        } else{
          this.dataState.isModalOpen=false;
          this.userOrSpec = 0;
          this.userSelected = null;
          this.userSpecSelected = null;
          this.specSelected = null;
          this.beginDateState.modalData = null;
          this.alreadyCreated = false
        }
      },
    },
    userSpecsState: {
      deep: true,
      handler(v) {
        if (v.isSuccess)
          this.checkAvailableSpec(this.beginDateState.modalData)
      }    
    },
    userSelected(v){
      if (v&&Object.keys(v).length>0) {
        this.specSelected = null
        this.getUserSelectedEventsAndSpecs();
        this.checkSameVisitPlans();
      }  
    },
    specSelected(v){
      if (v&&Object.keys(v).length>0) {  
        this.userSelected = null;
        this.userSpecSelected = null;
        this.getUserSelectedEventsAndSpecs();
        this.checkSameVisitPlans();
      }  
    },
    'beginDateState.modalData'(newDate) {
      if (newDate&&this.userSpecsState.isSuccess)
        this.checkAvailableSpec(newDate)
    },
  },
  methods:{
    allowedDates(val){
      if (this.userSelectedEvents.includes(val)) return val
    },
    visitCreate(){
      this.$emit('visitCreate', this.dataState.modalData)
    },
    deleteAction(){
      this.deleteState.stateLoading();
      axios.delete(Api.host+'/visitPlan/'+this.dataState.modalData.id+'/')
        .then(() =>{
          this.deleteState.stateSuccess();
          this.$emit('createdUpdatedDeleted');
        })
        .catch(e =>{
          this.deleteState.stateError();
          Api.responseError(e)
        });
    },
    createOrUpdate(){
      if (this.$refs.form.validate()) {
        let data = {};
        if(this.dataState.modalData.isLiveList){
          data.begin=moment().format('YYYY-MM-DD');
          data.isLiveList=true;
        } else {
          data.begin=moment(this.beginDateState.modalData+' '+this.beginTime+':00', 'DD.MM.YYYY HH:mm:ss').format('YYYY-MM-DD');
        }

        if(this.userSpecSelected) 
          data.userSpec = this.userSpecSelected.id;

        if(this.specSelected) 
          data.spec = this.specSelected.id;

        if(!this.$tools.isEmpty(this.dataState.modalData.comment)) data.comment = this.dataState.modalData.comment;

        this.updateState.stateLoading();
        if(typeof this.dataState.modalData.id==='undefined'){
          data.user = this.dataState.modalData.user.id;
          axios.post(Api.host+'/visitPlan/', data)
              .then(()=> {
                this.updateState.stateSuccess();
                this.$store.commit('alertSuccess', 'Ожидание визита создано');
                this.$emit('createdUpdatedDeleted');
              })
              .catch((error)=> {
                this.updateState.stateError();
                console.log(error)
              });
        } else {
          axios.put(Api.host+'/visitPlan/'+this.dataState.modalData.id+'/', data)
              .then(()=> {
                this.updateState.stateSuccess();
                this.$store.commit('alertSuccess', 'Ожидание визита обновлено');
                this.$emit('createdUpdatedDeleted');
              })
              .catch((error)=> {
                this.updateState.stateError();
                console.log(error)
              });
        }
      }
    },
    checkAvailableSpec(date) {
      let selectedDate = moment(date,'DD.MM.YYYY').format('YYYY-MM-DD')
      let activeSpecIndex = null
      this.userSpecSelected = null
      if (this.dataState.modalData.isLiveList) {
        selectedDate = moment().format('YYYY-MM-DD')
      }
      let day = this.userSelectedEventsSpecs[selectedDate]

      if (this.userSelected)
        this.userSpecs = this.usersSpecs.filter(i=>i.id===this.userSelected.id)[0]?.userSpecs;

      if(typeof this.userSpecs !=='undefined'&&this.userSpecs.length>0) {
        this.userSpecs.forEach((v)=>{
          v.name = v.spec.name+' < '+v.comDiv.comBranch.name;
        });

        //отключаем для выбора недоступные специализации
        this.userSpecs.forEach((spec,index) => {
          if (!this.onlyActiveUserSpecPlans){// если отключено, делаем все специализации доступными
            spec.disabled = false
          } else if (typeof day==='undefined'||!day.includes(spec.id)) {
            spec.disabled = true
          } else {
            spec.disabled = false
            if(activeSpecIndex === null)
              activeSpecIndex = index
          }
        });
       
        //Выбор специальности, 
        //если загружаем созданный, то выбирается ранее выбранная специализация, 
        //если новый, то первая доступная специальность в этот день
        if (activeSpecIndex !== null&&!this.alreadyCreated)
          this.userSpecSelected = this.userSpecs[activeSpecIndex]
        if (this.alreadyCreated&&this.dataState.modalData?.userSpec?.id) 
          this.userSpecSelected = this.dataState.modalData.userSpec
          this.alreadyCreated = false
      }
    },
    getUserSelectedEventsAndSpecs() {
      this.userSelectedEvents = [];
      this.userSelectedEventsColors = {};
      this.userSelectedEventsSpecs = {};

      if (this.userSelected||this.specSelected) {
        let rb = new Entity_UserSpecPlan()
        .selects(Entity_UserSpecPlan.id)
        .selects(Entity_UserSpecPlan.begin)
        .selects(Entity_UserSpecPlan.type)
        .selects(Entity_UserSpecPlan.status)
        .selects([Entity_UserSpecPlan.userSpec,Entity_UserSpec.id].join('.'))
        .selects([Entity_UserSpecPlan.userSpec,Entity_UserSpec.user,Entity_User.id].join('.'))
        .selects([Entity_UserSpecPlan.userSpec,Entity_UserSpec.spec, Entity_Spec.id].join('.'))
        .selects([Entity_UserSpecPlan.comPlace,Entity_ComPlace.comRoom,Entity_ComRoom.comFloor,Entity_ComFloor.comBuilding, Entity_ComBuilding.comBranch,Entity_ComBranch.id].join('.'))
        .selects([Entity_UserSpecPlan.comPlace,Entity_ComPlace.comRoom,Entity_ComRoom.comFloor,Entity_ComFloor.comBuilding, Entity_ComBuilding.comBranch,Entity_ComBranch.color].join('.'))
        
        if (!this.dataState.modalData.isLiveList) {
          rb.filterAnd([Entity_UserSpecPlan.entity, Entity_UserSpecPlan.begin].join('.')+'>=?',moment(this.daySelected).format('YYYY-MM-DD 00:00:00'));
        } else {
          rb.filterAnd([Entity_UserSpecPlan.entity, Entity_UserSpecPlan.begin].join('.')+'>=?',moment().format('YYYY-MM-DD 00:00:00'));
        }
        rb.filterAnd([Entity_UserSpecPlan.entity, Entity_UserSpecPlan.type].join('.')+' in (?)',['workVisit','workVisitReserve']);
        rb.filterAnd([Entity_UserSpecPlan.entity, Entity_UserSpecPlan.status].join('.')+'=?','active');

   
        if (this.userSelected) 
          rb.filterAnd([Entity_UserSpecPlan.entity, Entity_UserSpecPlan.userSpec, Entity_UserSpec.user,Entity_User.id].join('.')+'=?',this.userSelected.id);
        
        if(this.specSelected) 
          rb.filterAnd([Entity_UserSpecPlan.entity, Entity_UserSpecPlan.userSpec, Entity_UserSpec.spec, Entity_Spec.id].join('.')+'=?',this.specSelected.id);
        
 
        rb.page(1).onPage(3000);
        rb.addStateCallback((v)=> this.userSpecsState.setRequestBuilderState(v))
        rb.request((data)=>{
          if (data.count>0) {
            data.items.forEach(uSP=>{
              this.userSelectedEvents.push(this.$tools.dateTimeFormat(uSP.begin, 'YYYY-MM-DD'));

              let key = this.$tools.dateTimeFormat(uSP.begin, 'YYYY-MM-DD');
              let color = uSP.comPlace.comRoom.comFloor.comBuilding.comBranch.color;
              let spec = uSP.userSpec.id
 
              //colors
              if (typeof this.userSelectedEventsColors[key] === 'undefined')
                this.userSelectedEventsColors[key] = []
              if (!this.userSelectedEventsColors[key].includes(color)&&this.userSelectedEventsColors[key].length<3)
                this.userSelectedEventsColors[key].push(color)            
              //specs
              if (typeof this.userSelectedEventsSpecs[key] === 'undefined')
                this.userSelectedEventsSpecs[key] = []
              if (!this.userSelectedEventsSpecs[key].includes(spec))
                this.userSelectedEventsSpecs[key].push(spec)              
            });
          }
        }, (e)=>{
          console.error(e.response.data.message);
        })
      }
     
    },
    checkSameVisitPlans() {
        this.sameVisitPlans = [];

        let rb = new Entity_VisitPlan()
        .selects(Entity_VisitPlan.id)
        .selects(Entity_VisitPlan.begin)
        .selects(Entity_VisitPlan.isLiveList)
        .selects(Entity_VisitPlan.comment)


        .selects([Entity_VisitPlan.spec, Entity_Spec.id].join('.'))
        .selects([Entity_VisitPlan.spec, Entity_Spec.name].join('.'))

        .selects([Entity_VisitPlan.userSpec, Entity_UserSpec.id].join('.'))
        .selects([Entity_VisitPlan.userSpec, Entity_UserSpec.commentAdmin].join('.'))

        .selects([Entity_VisitPlan.userSpec, Entity_UserSpec.spec, Entity_Spec.id].join('.'))
        .selects([Entity_VisitPlan.userSpec, Entity_UserSpec.spec, Entity_Spec.name].join('.'))

        .selects([Entity_VisitPlan.userSpec, Entity_UserSpec.user, Entity_User.id].join('.'))
        .selects([Entity_VisitPlan.userSpec, Entity_UserSpec.user, Entity_User.firstName].join('.'))
        .selects([Entity_VisitPlan.userSpec, Entity_UserSpec.user, Entity_User.lastName].join('.'))
        .selects([Entity_VisitPlan.userSpec, Entity_UserSpec.user, Entity_User.secondName].join('.'))
        .selects([Entity_VisitPlan.userSpec, Entity_UserSpec.user, Entity_User.imageUrl].join('.'))

        .selects([Entity_VisitPlan.userSpec, Entity_UserSpec.comDiv, Entity_ComDiv.id].join('.'))
        .selects([Entity_VisitPlan.userSpec, Entity_UserSpec.comDiv, Entity_ComDiv.name].join('.'))
        .selects([Entity_VisitPlan.userSpec, Entity_UserSpec.comDiv, Entity_ComDiv.comBranch, Entity_ComBranch.id].join('.'))
        .selects([Entity_VisitPlan.userSpec, Entity_UserSpec.comDiv, Entity_ComDiv.comBranch, Entity_ComBranch.name].join('.'))

        .selects([Entity_VisitPlan.user, Entity_User.id].join('.'))
        .selects([Entity_VisitPlan.user, Entity_User.firstName].join('.'))
        .selects([Entity_VisitPlan.user, Entity_User.lastName].join('.'))
        .selects([Entity_VisitPlan.user, Entity_User.secondName].join('.'))
        .selects([Entity_VisitPlan.user, Entity_User.phone].join('.'))
        
        if (this.dataState.modalData.id)
          rb.filterAnd([Entity_VisitPlan.entity, Entity_VisitPlan.id].join('.')+' !=?',this.dataState.modalData.id);

        let userId = this.dataState.modalData.user.id;
        if (userId) 
          rb.filterAnd([Entity_VisitPlan.entity, Entity_VisitPlan.user, Entity_User.id].join('.')+'=?',userId);

        if (this.userSelected) 
          rb.filterAnd([Entity_VisitPlan.entity, Entity_VisitPlan.userSpec, Entity_UserSpec.user, Entity_User.id].join('.')+'=?',this.userSelected.id);

        if (this.specSelected)
          rb.filterAnd([Entity_VisitPlan.entity, Entity_VisitPlan.spec, Entity_Spec.id].join('.')+'=?',this.specSelected.id);

        rb.filterAnd([Entity_VisitPlan.entity, Entity_VisitPlan.isLiveList].join('.')+'=?', this.dataState.modalData.isLiveList ? 1: 0);
          

        rb.page(1).onPage(3000);

        rb.request((data)=>{
          this.sameVisitPlans = data.items;
        }, (e)=>{
            console.error(e.response.data.message);
        })

    }
  }
}
</script>